import { StickyBottomDrawer, styled, useResolution } from '@lingoda/ui';
import type { RouteConfigExtended } from '@lingoda/router';
import { TabValue } from '@lingoda/router';
import { trans } from '@lingoda/i18n';
import { BookOpen, CalendarIcon24, ExerciseIcon, HomeIcon24 } from '@lingoda/ui/icons/lingodaIcons';
import { type StickyBottomDrawerProps } from '@lingoda/ui';
import { topAndBottomTabsProps } from '../components/top-and-bottom-tabs-props';
import { useStudentActiveTab } from '../../../hooks';
import { BottomNavigationLinkAction } from './BottomNavigationLinkAction';
import { BottomNavigation } from './BottomNavigation';

export interface MobileBottomNavbarProps extends StickyBottomDrawerProps {
    routes: RouteConfigExtended[];
}

export const MobileBottomNavbar = ({
    routes,
    ...stickyBottomDrawerProps
}: MobileBottomNavbarProps) => {
    const { currentTabValue, handleChange } = useStudentActiveTab({ routes });
    const isPhablet = useResolution('phablet');

    return !isPhablet ? null : (
        <StickyBottomDrawer testId={'mobile-bottom-navbar'} {...stickyBottomDrawerProps}>
            <BottomNavigationStyled value={currentTabValue} onChange={handleChange} showLabels>
                <BottomNavigationLinkAction
                    value={TabValue.Home}
                    label={trans('navigation.user.today', {}, 'public-common')}
                    icon={<HomeIcon24 />}
                    {...topAndBottomTabsProps[TabValue.Home]}
                />
                <BottomNavigationLinkAction
                    value={TabValue.MyClasses}
                    label={trans('navigation.user.my-classes', {}, 'public-common')}
                    icon={<CalendarIcon24 />}
                    {...topAndBottomTabsProps[TabValue.MyClasses]}
                />
                <BottomNavigationLinkAction
                    value={TabValue.CourseOverview}
                    label={trans('navigation.user.my-course', {}, 'public-common')}
                    icon={<BookOpen />}
                    {...topAndBottomTabsProps[TabValue.CourseOverview]}
                />
                <BottomNavigationLinkAction
                    value={TabValue.Practice}
                    label={trans('navigation.user.practice', {}, 'public-common')}
                    icon={<ExerciseIcon />}
                    {...topAndBottomTabsProps[TabValue.Practice]}
                />
            </BottomNavigationStyled>
        </StickyBottomDrawer>
    );
};

const BottomNavigationStyled = styled(BottomNavigation)(() => ({
    width: '100%',
}));
